// @flow

// Modules
import React, { useEffect } from 'react';
import styled from 'styled-components';

// Components
import Button from 'components/button';

// Styles
import { BLUE_GREY } from 'src/styles/palettes';

// Methods
import { __ } from 'src/methods/l10n';

/**
 * Styles
 */

const PopupRoot = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 15px;
  background-color: #000a;
  z-index: 10000;
`;

const PopupContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 28em;
  padding: 1em 0;
  background-color: ${BLUE_GREY[900]};
  border-radius: 8px;
`;

const CloseButton = styled(Button)`
  text-transform: uppercase;
`;

/**
 * Types
 */

type PropTypes = {
  children: any,
  onHide: () => void
};

/*
 ** Component
 */

const Popup = (props: PropTypes): React$Element<any> => {
  const { children, onHide } = props;
  let popupRef: any = React.createRef();

  const handleClickOnDocument = (event: MouseEvent) => {
    if (popupRef && !popupRef.contains(event.target)) {
      onHide();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOnDocument);

    return () => {
      document.removeEventListener('click', handleClickOnDocument);
    };
  }, []);

  return (
    <PopupRoot>
      <PopupContent ref={(ref) => (popupRef = ref)}>
        {children}
        <CloseButton onClick={onHide}>{__('Close')}</CloseButton>
      </PopupContent>
    </PopupRoot>
  );
};

export default Popup;
